class ImageCarousel {
  static SCROLL_CHECK_INTERVAL_MS = 50

  constructor (container) {
    this.container = container
    this.carouselTrack = container.querySelector('.ContentTabs__CarouselTrack')
    this.prevButton = container.querySelector('.ContentTabs__CarouselPrev')
    this.nextButton = container.querySelector('.ContentTabs__CarouselNext')

    if (this.carouselTrack && this.prevButton && this.nextButton) {
      this.init()
    }
  }

  init () {
    this.setupNavigationListeners()
    this.setupScrollListener()
    this.updateButtonVisibility()
  }

  setupNavigationListeners () {
    this.prevButton.addEventListener('click', () => {
      this.scrollPrev()
    })

    this.nextButton.addEventListener('click', () => {
      this.scrollNext()
    })
  }

  scrollPrev () {
    const slide = this.carouselTrack.querySelector(
      '.ContentTabs__CarouselSlide'
    )
    if (!slide) return

    const slideWidth = slide.offsetWidth
    const gap = this.getGapSize()
    const scrollAmount = (slideWidth + gap) * 1 // Scroll by 1 item

    this.carouselTrack.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    })
  }

  scrollNext () {
    const slide = this.carouselTrack.querySelector(
      '.ContentTabs__CarouselSlide'
    )
    if (!slide) return

    const slideWidth = slide.offsetWidth
    const gap = this.getGapSize()
    const scrollAmount = (slideWidth + gap) * 1 // Scroll by 1 item

    this.carouselTrack.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    })
  }

  getGapSize () {
    // Get gap size based on screen width to match CSS
    if (window.matchMedia('(max-width: 768px)').matches) {
      return 10
    } else if (window.matchMedia('(max-width: 1024px)').matches) {
      return 15
    }
    return 20
  }

  setupScrollListener () {
    let lastScrollPos = this.carouselTrack.scrollLeft
    let scrollCheckInterval

    this.carouselTrack.addEventListener('scroll', () => {
      if (scrollCheckInterval) {
        clearInterval(scrollCheckInterval)
      }

      scrollCheckInterval = setInterval(() => {
        const currentScrollPos = this.carouselTrack.scrollLeft

        if (currentScrollPos === lastScrollPos) {
          clearInterval(scrollCheckInterval)
          scrollCheckInterval = null
          this.updateButtonVisibility()
        }

        lastScrollPos = currentScrollPos
      }, ImageCarousel.SCROLL_CHECK_INTERVAL_MS)
    })
  }

  updateButtonVisibility () {
    const maxScrollLeft =
      this.carouselTrack.scrollWidth - this.carouselTrack.clientWidth

    if (maxScrollLeft > 0) {
      this.prevButton.style.display = 'flex'
      this.nextButton.style.display = 'flex'

      // Hide prev button if at start
      if (this.carouselTrack.scrollLeft <= 1) {
        this.prevButton.style.display = 'none'
      }

      // Hide next button if at end
      if (this.carouselTrack.scrollLeft >= maxScrollLeft - 1) {
        this.nextButton.style.display = 'none'
      }
    } else {
      // No scrolling needed, hide both buttons
      this.prevButton.style.display = 'none'
      this.nextButton.style.display = 'none'
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const carouselContainers = document.querySelectorAll(
    '.ContentTabs__ImageCarousel .ContentTabs__CarouselWrapper'
  )
  const carouselInstances = []

  carouselContainers.forEach(container => {
    const instance = new ImageCarousel(container)
    carouselInstances.push(instance)
  })

  window.imageCarouselInstances = carouselInstances
})
